import { render, staticRenderFns } from "./AuthoriseLabourOld.vue?vue&type=template&id=289f1fd8&scoped=true"
import script from "./AuthoriseLabourOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseLabourOld.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseLabourOld.vue?vue&type=style&index=0&id=289f1fd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f1fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289f1fd8')) {
      api.createRecord('289f1fd8', component.options)
    } else {
      api.reload('289f1fd8', component.options)
    }
    module.hot.accept("./AuthoriseLabourOld.vue?vue&type=template&id=289f1fd8&scoped=true", function () {
      api.rerender('289f1fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseLabourOld.vue"
export default component.exports